<script>

export default {
    name: "InvoiceReport",

    data() {

        return {
            invoiceclaimstatus: [],
             activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            active: 0,
            organizations: [],
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.all([ this.fetchOrgs(),this.fetchClaimStatus() ]).then(() => {
            this.$root.loading = false;
        }).catch(() => {
            this.$root.loading = false;
        });
    },

    methods: {

        fetchOrgs() {

            return this.$http.get(`AccountsReports/GetOrganizations`).then(({data}) => {
                this.organizations = data;
            }).catch(() => {});
        },   
        fetchClaimStatus() {

let url = `Shared/GetClaimedStatus`;
return this.$http.get(url).then(({data}) => {
            this.invoiceclaimstatus=data;
        }).catch(() => {});
},
    },

    components: {

        "invoices-tab" : () => import('./tabs/Invoices.vue'),
        'proformas-tab': () => import('./tabs/Proformas.vue'),
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `reports.accounts-finance.index` }">Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Invoices report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Invoices</h5>
        </template>
        <template v-slot:card-body>
          <div class="w-full flex flex-wrap p-2">
                <ul class="w-full flex border-b-2 border-gray-500">
                    <li class="-mb-px mr-1">
                        <a href="javascript:void(0)" @click.prevent="active=0"
                           class="btn-sm text-sm text-gray-900 rounded-t-md inline-block
                            px-4 font-medium whitespace-no-wrap"
                           :class="active===0 ? activeClass : inActiveClass">
                            Invoices</a>
                    </li>
                    <li class="-mb-px mr-1">
                        <a href="javascript:void(0)" @click.prevent="active=1"
                          class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                          px-4 font-medium whitespace-no-wrap"
                          :class="active===1 ? activeClass : inActiveClass">
                            Proforma Invoices</a>
                    </li>
                </ul>
                <invoices-tab 
                    :organizations="organizations"
                    :invoiceclaimstatus="invoiceclaimstatus"
                    v-if="active===0" 
                />
                <proformas-tab 
                    :organizations="organizations"
                    v-if="active===1" 
                />
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>